// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"85df6012","317":"ebf46cc3","413":"8c3ac4f8","917":"ba027764"}[chunkId] + ".chunk.js";
};